import ActionTypes from '../lib/actionTypes';
import { PayloadAction } from '../lib/interfaces';
import { onFulfill, onPending, onReject } from '../lib/utils/actions';

export interface MeState {
  isLoading: boolean;
  me: Me | null;
}

export interface Me {
  caseCount: number;
  credits: number;
  email: string;
  id: number;
  emailVerified: boolean;
  barNumber: string | null;
  isLicenseKeySet: boolean;
}

interface MePayload {
  case_count: number;
  credits: number;
  email: string;
  id: number;
  email_verified: boolean;
  bar_number: string;
  licence_key: string;
  is_licence_key_set: boolean;
}

const initialState = {
  isLoading: false,
  me: null,
};

export function me(
  state: MeState = initialState,
  action: PayloadAction<MePayload> = {} as PayloadAction<MePayload>,
): MeState {
  switch (action.type) {
    case onPending(ActionTypes.LOGIN):
    case onPending(ActionTypes.SESSION):
    case onPending(ActionTypes.LOGOUT):
    case onPending(ActionTypes.CREATE_USER):
    case onPending(ActionTypes.REQUEST_VERIFICATION):
    case onPending(ActionTypes.FORGOT_PASSWORD):
    case onPending(ActionTypes.RESET_PASSWORD):
      return {
        ...state,
        isLoading: true,
      };

    case onReject(ActionTypes.LOGIN):
    case onReject(ActionTypes.SESSION):
    case onReject(ActionTypes.LOGOUT):
    case onReject(ActionTypes.CREATE_USER):
    case onReject(ActionTypes.REQUEST_VERIFICATION):
    case onReject(ActionTypes.FORGOT_PASSWORD):
    case onReject(ActionTypes.RESET_PASSWORD):
    case onFulfill(ActionTypes.CREATE_USER):
    case onFulfill(ActionTypes.REQUEST_VERIFICATION):
    case onFulfill(ActionTypes.FORGOT_PASSWORD):
    case onFulfill(ActionTypes.RESET_PASSWORD):
      return {
        ...state,
        isLoading: false,
      };

    case onFulfill(ActionTypes.LOGOUT):
      return {
        ...initialState,
      };

    case onFulfill(ActionTypes.UPDATE_FILER_INFO):
    case onFulfill(ActionTypes.SESSION):
    case onFulfill(ActionTypes.LOGIN):
    case onFulfill(ActionTypes.GET_CURRENT_USER):
      return {
        ...state,
        me: {
          caseCount: action.payload!.user.case_count,
          credits: action.payload!.user.credits || 0,
          email: action.payload!.user.email,
          id: action.payload!.user.id,
          emailVerified: action.payload!.user.email_verified,
          barNumber: action.payload!.user.bar_number || null,
          isLicenseKeySet: action.payload!.user.is_licence_key_set,
        },
        isLoading: false,
      };

    case ActionTypes.CREDITS_UPDATE:
      if (!state.me) return state;
      return {
        ...state,
        me: {
          ...state.me,
          credits: Number(action.payload || 0),
        },
      };

    default:
      return state;
  }
}
